import { omittedPriceSettingConverter } from "./base-converter";

import type { Multi } from "..";
import type { RowData } from "../../../discount-table";

/**
 * MultiDiscount の行データを生成する
 */
export const multiRowsDataConverter = (
	multiList: Multi,
	ordinaryAndLongTermStayDiscountIdWithNames: Array<{ id: string; name: string }>,
): Array<RowData> => {
	return multiList.map((discount) => {
		const discountPriceTotalLimitAmount = discount.discountPriceTotalLimit?.amount ?? undefined;
		const convertedBasic = omittedPriceSettingConverter(
			discount.discountID,
			discount.name,
			discount.discountCode,
			discount.discountPriceTotal.amount,
			discount.inSale,
			discountPriceTotalLimitAmount,
		);
		const convertedPriceSetting = discount.multiDiscounts
			.filter((discountID) =>
				ordinaryAndLongTermStayDiscountIdWithNames.some((discount) => discountID === discount.id),
			)
			.map((discountID, index) => {
				const tar = ordinaryAndLongTermStayDiscountIdWithNames.find((discount) => discountID === discount.id);
				const discountName = tar!.name;
				return `${index + 1}. ${discountName}`;
			})
			.join("\n");

		return {
			...convertedBasic,
			priceSetting: convertedPriceSetting,
		} satisfies RowData;
	}) satisfies Array<RowData>;
};
